import { WorkplaceGroupFragment } from '@api/fragments'
import { IWorkplaceGroup } from '@api/types'
import { client } from '@stores'
import handleFetchResult from '@utils/handleFetchResult'
import gql from 'graphql-tag'

interface IPayload {
  addDepartmentToWorkplaceGroup: {
    workplaceGroup: IWorkplaceGroup
  }
}

const mutateHandler = handleFetchResult<IPayload, IWorkplaceGroup>({
  handler: (data) => data.addDepartmentToWorkplaceGroup.workplaceGroup,
  name: 'Workplace Group',
})

const mutation = gql`
  mutation AddDepartmentsToWorkplaceGroup($input: AddDepartmentsToWorkplaceGroupInput!) {
    addDepartmentToWorkplaceGroup(input: $input) {
      workplaceGroup {
        ...WorkplaceGroupFragment
      }
    }
  }
  ${WorkplaceGroupFragment}
`

export default function addDepartmentToWorkplaceGroup(
  workplaceGroupId: string,
  departmentIds: string[]
): Promise<IWorkplaceGroup> {
  const input = { workplaceGroupId, departmentIds }

  return client.gql.mutate({ mutation, variables: { input } }).then(mutateHandler)
}
